import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { environment } from '../../../../environments/environment';
import { Helpers } from '../../../helpers';
import { DataService } from '../../../_services/data.service';

@Injectable()
export class UserAuthenticationService {
    constructor(private http: Http, private dataService: DataService) { }

    login(email: string, password: string) {
        var url = environment.ownerApiEndpoint + '/authenticate/userlogin';
        return this.http
            .post(url, JSON.stringify({ email: email, password: password }), {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'q=0.8;application/json;q=0.9'
                })
            })
            .map((response: Response) => {
                let res = response.json();

                if (!res.status) {
                    throw res.errorMessage;
                }
                if (res && res.token) {
                    var authData = { token: res.token };
                    this.dataService.setAuthData(authData);
                    this.dataService.setUser(res.data);
                }
            });
    }

    logout() {
        this.dataService.removeAuthData();
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/user/_services/authentication.service.ts